export default __webpack_public_path__ + "static/media/top_mobile_banner_SimplyCLICK.cb6ccd1e.png";